import { Box, Typography } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import '../../css/dashboardListViewData.css';

const DashboardListViewData = ({ site, columnWidth }) => {

  if (!site) {
    return (
      <Box className='dashboard_table_row'>
        <Box className='dashboard_tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.name, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}><Skeleton variant="text" width="100%" /></Box>
        <Box className='dashboard_tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.purchase_price, position: 'sticky', right: columnWidth.total_expenses, backgroundColor: 'white', zIndex: 1 }}><Skeleton variant="text" width="100%" /></Box>
        <Box className='dashboard_tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.total_expenses, position: 'sticky', right: 0, backgroundColor: 'white', zIndex: 1 }}><Skeleton variant="text" width="100%" /></Box>
      </Box>
    );
  }

  return (
    <Box className='dashboard_table_row'>
      <Box className='dashboard_tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.name, maxWidth: columnWidth.name, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}>
        <Typography className='tableBodyTypography'>{site?.name}</Typography>
      </Box>
      <Box className='dashboard_tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.purchase_price, maxWidth: columnWidth.purchase_price, position: 'sticky', right: columnWidth.total_expenses, backgroundColor: 'white', zIndex: 1 }}>
        <Typography className='tableBodyTypography' sx={{ textAlign: 'end' }}>
          {new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(site?.total_machine_price) || '0,00 €'}
        </Typography>
      </Box>
      <Box className='dashboard_tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.total_expenses, maxWidth: columnWidth.total_expenses, position: 'sticky', right: 0, backgroundColor: 'white', zIndex: 1 }}>
        <Typography className='tableBodyTypography' sx={{ textAlign: 'end' }}>
          {new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(site?.total_expenses) || '0,00 €'}
        </Typography>
      </Box>
    </Box>
  );
};

export default DashboardListViewData;